module.exports = __webpack_public_path__ + "DINNextLTPro-Condensed.ttf?8adaf05a664a9ebb62530f81f9407e32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Condensed.ttf
// module id = 1402
// module chunks = 0